import { render, staticRenderFns } from "./GetTheAppButton.vue?vue&type=template&id=070ebd54&scoped=true&"
import script from "./GetTheAppButton.vue?vue&type=script&lang=js&"
export * from "./GetTheAppButton.vue?vue&type=script&lang=js&"
import style0 from "./GetTheAppButton.vue?vue&type=style&index=0&id=070ebd54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ebd54",
  null
  
)

export default component.exports